import { SiteDTO, SiteIntegrationTypeEnum } from '@beable/roster-backend-client-v1';
import { Result } from 'true-myth'
import axios, { AxiosResponse } from 'axios';
import RosterBackendService from './RosterBackendService';
import { jsonToQueryString } from '../util/jsonToQueryString';

export async function uploadArchive(target: File, site?: SiteDTO, type?: string, academicYear?: string): Promise<AxiosResponse<any> | null> {
  const formData = new FormData();

  const query: { [key: string]: any } = {
    academicYear: academicYear    || '',
    siteId      : site?.id        || '',
    subdomain   : site?.subdomain || '',
    type        : type            || '',
  };

  const queryString = jsonToQueryString(query);

  formData.append('file', target);

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/csv/upload?${queryString}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      });
    return response;

  } catch (error) {
    return null;
  }
}


export async function triggerSync(siteId: number, type: SiteIntegrationTypeEnum | undefined): Promise<Result<boolean, Error>> {
  let resp: Result<any, any>;

  if (type && type === SiteIntegrationTypeEnum.CleverAPI) {
    resp = await RosterBackendService.triggerCleverAPISync({ siteId });
  } else {
    resp = await RosterBackendService.triggerOneRosterAPISync(siteId);
  }

  if ( resp.isErr() ) {
    return Result.err(new Error(resp.error.message));
  }

  return Result.ok(true);
}
